import i18n from 'Pods/Shared/I18nThreeDStudio'

const NAMESPACE = 'three-d-studio'

const LOCALE_LOADERS = {
  es: () => import(/* webpackChunkName: "three-d-studio-es" */ 'Translations/ThreeDStudioEs'),
  ru: () => import(/* webpackChunkName: "three-d-studio-ru" */ 'Translations/ThreeDStudioRu'),
  fr: () => import(/* webpackChunkName: "three-d-studio-fr" */ 'Translations/ThreeDStudioFr'),
  pt: () => import(/* webpackChunkName: "three-d-studio-pt" */ 'Translations/ThreeDStudioPt'),
  de: () => import(/* webpackChunkName: "three-d-studio-de" */ 'Translations/ThreeDStudioDe'),
  'zh-CN': () => import(/* webpackChunkName: "three-d-studio-zh-cn" */ 'Translations/ThreeDStudioZh-CN'),
  ja: () => import(/* webpackChunkName: "three-d-studio-ja" */ 'Translations/ThreeDStudioJa'),
}

const pending = {}

function pageLocale() {
  return typeof document === 'undefined' ? 'en' : document.documentElement.lang
}

// Resolves once the three-d-studio translation bundle for the given locale is
// registered. English is bundled statically in Pods/Shared/I18nThreeDStudio, so
// it (and any unknown locale, which falls back to English) resolves immediately.
//
// USAGE CONTRACT — the three_d_studio pack must not mount components until the
// returned promise resolves, otherwise non-EN pages hydrate in English before
// the bundle arrives (English flash + React hydration mismatch).
function loadThreeDStudioLocaleBundle(locale = pageLocale()) {
  const loader = LOCALE_LOADERS[locale]

  if (!loader) return Promise.resolve()

  if (!pending[locale]) {
    pending[locale] = loader().then(({ default: bundle }) => {
      i18n.addResourceBundle(locale, NAMESPACE, bundle, true, true)
    }).catch((error) => {
      // Chunk failed to load (network blip, purged hash after a deploy):
      // resolve anyway so the pack still mounts with the English fallback, and
      // drop the memo so a later call can retry. Best-effort Sentry report via
      // the global set by initSentry (Utils/SentryConfig); no static Sentry
      // import so the pack does not grow.
      delete pending[locale]
      if (typeof window !== 'undefined' && typeof window.sendErrorToSentry === 'function') {
        window.sendErrorToSentry(error, { tags: { locale } })
      }
    })
  }

  return pending[locale]
}

export default loadThreeDStudioLocaleBundle
